import { render, staticRenderFns } from "./promoNews.vue?vue&type=template&id=b04d4694&scoped=true&lang=pug"
import script from "./promoNews.vue?vue&type=script&lang=js"
export * from "./promoNews.vue?vue&type=script&lang=js"
import style0 from "./promoNews.vue?vue&type=style&index=0&id=b04d4694&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04d4694",
  null
  
)

export default component.exports